import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  cropName: '',
  image1: null,
  image2: null,
  image3: null,
  isUploadInProgress: false,
  isCreateCropInProgress: false,
  isGetCropInProgress: false,
  isEditCropInProgress: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.UPLOAD_IMAGE_SUCCESS:
    case actionTypes.DELETE_IMAGE_SUCCESS:
      if (action.payload.type === 'crop') {
        return Object.assign({}, state, {
          [action.payload.key]: action.payload.image,
        });
      } else {
        return state;
      }
    case '@@redux-form/RESET':
      if (
        action.meta.form === 'addNewCrop' ||
        action.meta.form === 'editCropForm'
      ) {
        return initialState;
      } else {
        return state;
      }
    case actionTypes.FETCH_CROP_INFO_SUCCESS:
      return Object.assign({}, state, {
        cropName: action.payload.crop.name,
        image1:
          (action.payload.crop.images[0] && action.payload.crop.images[0]) ||
          null,
        image2:
          (action.payload.crop.images[1] && action.payload.crop.images[1]) ||
          null,
        image3:
          (action.payload.crop.images[2] && action.payload.crop.images[2]) ||
          null,
      });
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.DELETE_IMAGE:
        case 'ALL':
          return Object.assign({}, state, { isUploadInProgress: true });
        case actionTypes.CREATE_CROP:
          return Object.assign({}, state, { isCreateCropInProgress: true });
        case actionTypes.FETCH_CROP_INFO:
          return Object.assign({}, state, { isGetCropInProgress: true });
        case actionTypes.EDIT_CROP:
          return Object.assign({}, state, { isEditCropInProgress: true });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.DELETE_IMAGE:
        case 'ALL':
          return Object.assign({}, state, { isUploadInProgress: false });
        case actionTypes.CREATE_CROP:
          return Object.assign({}, state, { isCreateCropInProgress: false });
        case actionTypes.FETCH_CROP_INFO:
          return Object.assign({}, state, { isGetCropInProgress: false });
        case actionTypes.EDIT_CROP:
          return Object.assign({}, state, { isEditCropInProgress: false });
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
